import { Flags } from "components/Flags";
import type { ReactStoryblokComponent } from "types/storyblok";

const FlagsAdapter = ({ sbEditable }: ReactStoryblokComponent<unknown>) => <Flags sbEditable={sbEditable} />;

export default FlagsAdapter;
